import { ChipProps } from "@mui/material"

export enum AI_HS_CODE_LABELING_TAB_KEY {
  single_search = "single_search",
  bulk_uploading_search = "bulk_uploading_search",
}

export const AI_HS_CODE_LABELING_TABS: ITabSetting[] = [
  {
    label: 'Single SEARCH',
    key: AI_HS_CODE_LABELING_TAB_KEY.single_search,
  },
  {
    label: 'BULK UPLOAD SEARCH',
    key: AI_HS_CODE_LABELING_TAB_KEY.bulk_uploading_search,
  },
]

export const getConfidenceTagColor: (value: number) => ChipProps['color'] = (value: number) => {
  if (value > 80) return 'success'
  if (value <= 80 && value > 60) return 'info'
  if (value <= 60 && value > 20) return 'warning'
  return 'error'
}


